<template>
  <swipeModal ref="myBottomSheet" v-model="isModal"
              contents-height="20vh"
              border-top-radius="16px">
    <div class="delivery-modal">
      <TheEstimateStepForAddress dir="start"
                                 v-model:address="addressFromParent"
                                 v-model:address_detail="address_detailFromParent"
                                 v-model:sigungu="address_sigunguFromParent"
                                 v-model:bname="address_bnameFromParent"
                                 v-model:zipcode="address_zipcodeFromParent"
                                 title="배송지 주소"
                                 version="2"
                                 extendMobilePopup="postWrap"
                                 :showMobileAddressModal="() => { addressModal = true; }"
                                 :closeMobileAddressModal="() => { addressModal = false; }"
      >
        <template v-slot:titleSlot>
          <button v-if="$store.state.auth.isLogin" type="button" class="btn btn-load-address" @click="showAddressModal">주소록 불러오기</button>
        </template>
      </TheEstimateStepForAddress>

      <TheStorageDeliveryDate
          :box_cnt="box_cnt"
          v-model:delivery_date="delivery_dateFromParent"
          v-model:delivery_time="delivery_timeFromParent"
          v-model:collection_date="collection_dateFromParent"
          v-model:collection_time="collection_timeFromParent"
          type="first"
      ></TheStorageDeliveryDate>

      <button class="btn btn-primary btn-block btn-confirm-order btn-default-square" @click="onOrderComplete">주문 확인하러 가기</button>
    </div>
  </swipeModal>

  <Modal @close="addressModal = false" class="address-modal" :class="{ hide: !addressModal }">
    <div class="modal-header">주소검색</div>
    <div class="modal-body text-center" id="postWrap"></div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import swipeModal from '@takuma-ru/vue-swipe-modal'
import TheEstimateStepForAddress from "@/components/estimate/TheEstimateStepForAddress";
import TheStorageDeliveryDate from "@/components/TheStorageDeliveryDate";

export default {
  name: "TheEstimateDeliveryPopupV2",
  components: {
    Modal,
    swipeModal,
    TheEstimateStepForAddress,
    TheStorageDeliveryDate,
  },
  props: [
      'box_cnt',
      'modelValue',
      'address',
      'address_detail',
      'address_sigungu',
      'address_bname',
      'address_zipcode',
      'delivery_date',
      'delivery_time',
      'collection_date',
      'collection_time',
      'onOrderComplete',
      'showAddressModal'
  ],
  emits: [
      'update:modelValue',
      'update:delivery_date',
      'update:delivery_time',
      'update:collection_date',
      'update:collection_time'
  ],
  computed: {
    addressFromParent: {
      get() { return this.address; },
      set(newValue) { this.$emit('update:address', newValue); }
    },
    address_detailFromParent: {
      get() { return this.address_detail; },
      set(newValue) { this.$emit('update:address_detail', newValue); }
    },
    address_sigunguFromParent: {
      get() { return this.address_sigungu; },
      set(newValue) { this.$emit('update:address_sigungu', newValue); }
    },
    address_bnameFromParent: {
      get() { return this.address_bname; },
      set(newValue) { this.$emit('update:address_bname', newValue); }
    },
    address_zipcodeFromParent: {
      get() { return this.address_zipcode; },
      set(newValue) { this.$emit('update:address_zipcode', newValue); }
    },
    delivery_dateFromParent: {
      get() { return this.delivery_date; },
      set(newValue) { this.$emit('update:delivery_date', newValue); }
    },
    delivery_timeFromParent: {
      get() { return this.delivery_time; },
      set(newValue) { this.$emit('update:delivery_time', newValue); }
    },
    collection_dateFromParent: {
      get() { return this.collection_date; },
      set(newValue) { this.$emit('update:collection_date', newValue); }
    },
    collection_timeFromParent: {
      get() { return this.collection_time; },
      set(newValue) { this.$emit('update:collection_time', newValue); }
    }
  },
  data() {
    return {
      timeList: {
        delivery: [],
        collection: []
      },
      isModal: false,
      addressModal: false
    }
  },
  methods: {
    close() {
      document.getElementsByClassName('modal-background')[0].click()
      // this.isModal = false;
      // this.$refs.myBottomSheet.close();
      // this.$emit('update:modelValue', false);
    },
    open() {
      this.$emit('update:delivery_date', null);
      this.$emit('update:delivery_time', 'none');
      this.$emit('update:collection_date', null);
      this.$emit('update:collection_time', 'none');
      this.isModal = true;
    },
  }
}
</script>

<style scoped lang="scss">
</style>
<style lang="scss">
  .delivery-modal {
    padding: 15px;

    .input-group {
      margin: 0;
    }

    .btn-load-address {
      font-size: 10px;
      padding: 4px 10px;
      border-radius: 10px;
      float: right;
      line-height: 15px;
      color: #000;
    }

    .btn-confirm-order {
      height: 55px;
      margin-top: 44px;
    }

    @include respond(mobile) {
      .btn-default-square {
        font-size: 12px;
      }
    }

  }
</style>
<style lang="scss">
@include respond(tablet) {
  .swipe-modal-takumaru-vue-swipe-modal .modal-contents-chip-wrapper {
    padding: 0;
    margin-top: 18px;
    margin-bottom: 8px;
  }
}


@include respond(desktop) {
  .estimate-form .swipe-modal-takumaru-vue-swipe-modal .modal-contents {
    width: 375px !important;
    margin-bottom: 50vh;
    transform: translate(-50%) translateY(50%);
    border-radius: 10px !important;
  }

  .estimate-form .delivery-modal {
    padding: 24px 15px 40px;
  }
}

</style>
